export default __webpack_public_path__ + "static/media/train.2a3aa465.svg";